import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, TrendingUp, Briefcase, Bot } from "lucide-react";

const audiences = [
  { icon: GraduationCap, title: "University Students", text: "Master the study systems and habits that consistently earn first-class results." },
  { icon: TrendingUp, title: "Graduates", text: "Stand out in a crowded market and turn your degree into real career momentum." },
  { icon: Briefcase, title: "Professionals", text: "Sharpen judgement, learn faster and stay competitive as your industry evolves." },
  { icon: Bot, title: "AI Learners", text: "Use artificial intelligence as a genuine advantage without becoming dependent on it." },
];

export default function WhoFor() {
  return (
    <section id="who-for" className="py-28 sm:py-36">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-2xl mb-16">
          <span className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">Written For You</span>
          <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-4">Who These Books Are For</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-7">
          {audiences.map((a, i) => {
            const Icon = a.icon;
            return (
              <motion.div
                key={a.title}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="rounded-3xl p-8 bg-[#0A0A0A] text-white overflow-hidden relative gold-glow"
                data-testid={`who-for-${i}`}
              >
                <span className="inline-grid place-items-center h-14 w-14 rounded-2xl bg-gold text-black mb-6">
                  <Icon size={26} />
                </span>
                <h3 className="font-display text-xl font-bold mb-2">{a.title}</h3>
                <p className="text-sm text-gray-400 leading-relaxed">{a.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
